<div class="watch-list-table">
  <app-table
    [statesColumns]="statesColumns()"
    [settings]="{
			size: 'sm',
			emptyTextPath: 'watchList.empty',
			rowClickable: true,
			defaultSort: widget()?.settings?.activeSort ?? { prop: 'percentage_change', type: 'desc' },
		}"
    [items]="this.watchList()?.assets || []"
    [isLoading]="isLoading()"
    (rowClick)="setLiveTicker($event)"
    (onChangeSort)="changeSort($event)"
  >
    <app-table-column
      [settings]="{
				titlePath: 'watchList.ticker',
				column: watchListColumnsEnum.ticker,
				canSort: true,
				propSort: 'symbol',
				minWidthPx: 100,
				maxWidthPx: 130,
			}"
    >
      <ng-template let-item="item">
				<span class="asset-ticker">
					<app-company-logo
            [logoSrc]="item.icon"
            [symbol]="item.symbol"
            [logoAlt]="item.symbol"
          />
					<span class="title">{{ item.symbol }}</span>
				</span>
      </ng-template>
    </app-table-column>

    <app-table-column
      [settings]="{
				titlePath: 'watchList.company',
				column: watchListColumnsEnum.company,
				canSort: true,
				propSort: 'description',
				minWidthPx: 170,
				maxWidthPx: 210,
			}"
    >
      <ng-template let-item="item">
        <span class="text">{{ item.description }}</span>
      </ng-template>
    </app-table-column>

    <app-table-column
      [settings]="{
				titlePath: 'watchList.price',
				column: watchListColumnsEnum.price,
				canSort: true,
				propSort: 'close',
				minWidthPx: 70,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
    >
      <ng-template let-item="item">
        <div class="cell-column">
          <span class="text">{{ item.close | price }}</span>
          @if (!isMarket() && item.last_trade_price) {
            @let currentStatus = marketStatus()?.status ?? null;
            @let iconsByMarketStatus = iconsByMarketStatusMap.get(currentStatus);
            @let isLightTheme = theme() === themeEnum.LIGHT;
            <div class="sub-text">
              <img
                class="img"
                [src]="isLightTheme ? iconsByMarketStatus?.lightUrl : iconsByMarketStatus?.darkUrl"
                [alt]="iconsByMarketStatus?.alt | translate"
              />
              <span class="text">{{ item.last_trade_price | price }}</span>
            </div>
          }
        </div>
      </ng-template>
    </app-table-column>

    <app-table-column
      [settings]="{
				titlePath: 'watchList.watchListChangeColumnDollar',
				column: watchListColumnsEnum.watchListChangeColumnDollar,
				canSort: true,
				propSort: 'previous_price_change',
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
    >
      <ng-template let-item="item">
        <div class="cell-column">
					<span
            class="text"
            highlight
            [isPositive]="(item.previous_price_change ?? 0) > 0"
            [isNegative]="(item.previous_price_change ?? 0) < 0"
            [isNeutral]="!item.previous_price_change"
          >
						{{ item.previous_price_change | profit: 'dollar' }}
					</span>
          @if (!isMarket() && item.last_trade_price) {
            <div class="sub-text">
							<span
                class="text"
                highlight
                [isPositive]="(item.price_change ?? 0) > 0"
                [isNegative]="(item.price_change ?? 0) < 0"
                [isNeutral]="!item.price_change"
              >
								{{ item.price_change | profit: 'dollar' }}
							</span>
            </div>
          }
        </div>
      </ng-template>
    </app-table-column>

    <app-table-column
      [settings]="{
				titlePath: 'watchList.watchListChangeColumnPercent',
				column: watchListColumnsEnum.watchListChangeColumnPercent,
				canSort: true,
				propSort: 'previous_percentage_change',
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
    >
      <ng-template let-item="item">
        <div class="cell-column">
					<span
            class="text"
            highlight
            [isPositive]="(item.previous_percentage_change ?? 0) > 0"
            [isNegative]="(item.previous_percentage_change ?? 0) < 0"
            [isNeutral]="!item.previous_percentage_change"
          >
						{{ item.previous_percentage_change | profit: 'percent' }}
					</span>
          @if (!isMarket() && item.last_trade_price) {
            <div class="sub-text">
							<span
                class="text"
                highlight
                [isPositive]="(item.percentage_change ?? 0) > 0"
                [isNegative]="(item.percentage_change ?? 0) < 0"
                [isNeutral]="!item.percentage_change"
              >
								{{ item.percentage_change | profit: 'percent' }}
							</span>
            </div>
          }
        </div>
      </ng-template>
    </app-table-column>

    <app-table-footer>
      <ng-template>
        <div class="footer">
          <app-button
            appearance="primary"
            size="m"
            (clicked)="toggleSearchAssets(true)"
          >
            {{ 'watchList.addStocks' | translate }}
          </app-button>
        </div>
      </ng-template>
    </app-table-footer>

    <app-table-actions>
      <ng-template let-item="item">
        <app-watch-list-actions [asset]="item"/>
      </ng-template>
    </app-table-actions>
  </app-table>
</div>

<ng-template [(tuiDialog)]="isOpenSearchAssets">
  <app-search-assets-dialog (closeDialog)="toggleSearchAssets(false)"/>
</ng-template>
